import { collection, query, where, getDocs, updateDoc, doc, Timestamp } from 'firebase/firestore';
import { db } from '../config/firebase';

class RecencyService {
  async calculateRecency(userId) {
    try {
      const now = new Date();
      const thirtyDaysAgo = new Date(now.getTime() - (30 * 24 * 60 * 60 * 1000));
      const ninetyDaysAgo = new Date(now.getTime() - (90 * 24 * 60 * 60 * 1000));

      // Get experience collection
      const experienceRef = collection(db, `pilot/${userId}/experience`);
      
      // Query all flights in last 90 days
      const recentFlightsQuery = query(
        experienceRef,
        where('date', '>=', ninetyDaysAgo)
      );

      const querySnapshot = await getDocs(recentFlightsQuery);
      
      let last90DaysFlightHours = 0;
      let flightHoursLast30Days = 0;
      let nightHoursLast30Days = 0;
      let hasRecentFlights = false;

      querySnapshot.forEach((doc) => {
        const flight = doc.data();
        const flightDate = flight.date.toDate();
        
        // Calculate 90 days total
        if (flightDate >= ninetyDaysAgo) {
          last90DaysFlightHours += Number(flight.totaltime) || 0;
        }
        
        // Calculate 30 days totals
        if (flightDate >= thirtyDaysAgo) {
          flightHoursLast30Days += Number(flight.totaltime) || 0;
          nightHoursLast30Days += Number(flight.night) || 0;
          hasRecentFlights = true;
        }
      });

      // Update pilot document
      const pilotRef = doc(db, 'pilot', userId);
      await updateDoc(pilotRef, {
        last90DaysFlightHours,
        flightHoursLast30Days,
        nightHoursLast30Days,
        lastRecencyCheck: Timestamp.now()
      });

      return {
        hasRecentFlights,
        recencyData: {
          last90DaysFlightHours,
          flightHoursLast30Days,
          nightHoursLast30Days
        }
      };
    } catch (error) {
      console.error('Error calculating recency:', error);
      throw error;
    }
  }
}

const recencyService = new RecencyService();
export default recencyService; 